import FulfillmentQueue from './FulfillmentQueue';
export default function FulfillmentShip() {
  return (
    <FulfillmentQueue
      title="Ship"
      statusFilter={['packed', 'awaiting_label', 'awaiting_pickup']}
      showStatusCol={true}
      emptyMessage="No orders ready to ship"
    />
  );
}
